import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

const STATUS_ACTIONS = [
  {
    status: 'PUBLISHED',
    label: 'Publish',
    variant: 'publish',
    icon: ['fas', 'paper-plane'],
  },
  {
    status: 'PREVIEW',
    label: 'Preview',
    variant: 'preview',
    icon: ['fas', 'eye'],
  },
  {
    status: 'UNPUBLISHED',
    label: 'Save Draft',
    variant: 'draft',
    icon: ['fas', 'floppy-disk'],
  },
  {
    status: 'DELETED',
    label: 'Delete',
    variant: 'delete',
    icon: ['fas', 'trash-can'],
  },
];

function statusHint(status) {
  switch (status) {
    case 'PUBLISHED':
      return 'This event is live and visible to the public.';
    case 'PREVIEW':
      return 'Preview mode — test before going live.';
    case 'DELETED':
      return 'This event has been deleted.';
    case 'UNPUBLISHED':
    default:
      return 'Draft saved recently.';
  }
}

function statusButtonClass(variant, isActive) {
  return cn(
    'bethere-status-btn',
    isActive
      ? `bethere-status-btn--${variant}-active`
      : `bethere-status-btn--${variant}-outline`,
  );
}

export function FestivalEventStatusPanel({
  festivalId,
  status = 'UNPUBLISHED',
  readOnly = false,
  isPending = false,
  onStatusChange,
}) {
  const currentStatus = status || 'UNPUBLISHED';

  const handleClick = (nextStatus) => {
    if (readOnly || isPending || nextStatus === currentStatus) {
      return;
    }
    if (
      nextStatus === 'DELETED' &&
      !window.confirm(
        'Delete this event? It will be removed from listings until restored.',
      )
    ) {
      return;
    }
    onStatusChange(nextStatus);
  };

  return (
    <div className="glass-panel p-6">
      <h3 className="m-0 text-lg font-bold text-[#121212]">Event Status</h3>
      <p className="mt-2 text-sm leading-relaxed text-[var(--festy-muted-text)]">
        {statusHint(currentStatus)}
      </p>
      <div
        className="bethere-sidebar-actions"
        role="group"
        aria-label="Event status actions"
      >
        {STATUS_ACTIONS.map(({ status: st, label, variant, icon }) => {
          const isActive = currentStatus === st;
          return (
            <button
              key={st}
              type="button"
              className={statusButtonClass(variant, isActive)}
              aria-pressed={isActive}
              disabled={readOnly || isPending}
              onClick={() => handleClick(st)}
            >
              <FontAwesomeIcon icon={icon} className="text-[length:var(--bethere-f-p)]" />
              {label}
            </button>
          );
        })}
      </div>
      {festivalId && (
        <p className="mt-4 text-xs text-[var(--festy-muted-text)]">
          <Link
            to={`/festival/${festivalId}/view`}
            className="font-bold text-[var(--bethere-primary)] hover:text-[var(--bethere-tertiary)]"
          >
            View published layout
          </Link>
        </p>
      )}
    </div>
  );
}
